import { Strings } from "@constant";
import { StoreTransactionsPage } from "@containers";
import { useEffect } from "react";

export const StoreTransactions = () => {
  useEffect(() => {
    document.title = Strings.pageTitle("Store Transactions");
  });

  return (
    <>
      <StoreTransactionsPage />
    </>
  );
};
